import axios from './request'
import config from '@/config'
import utils from '@/utils/utils'

const { baseURL } = config;
const inMobileApp = MG.utils.getQueryString('linkFrom') == '10086' // 分省
const inMiguApp = utils.isMiguApp() // 快游app内

const getHeaders = () => {
    const appType = inMobileApp ? 8 : 4 // 端内端外appType:4，分省appType:8
    const appChannel = MG.utils.getQueryString('channel') || MG.utils.getQueryString('appChannel') || ''
    const userId = localStorage.getItem('userId') ? +localStorage.getItem('userId') : ''
    const userToken = localStorage.getItem('userToken')
    return {
        userId,
        userToken,
        appType,
        appChannel,
    }
}

// 首次登录查询接口
export function queryCopyWriting(param) {
    let url = baseURL + 'game/copywriting/v1.0.2.5/queryCopyWriting';
    return axios.post(url, param.data, { headers: param.headers })
}

// 积分活动地址保存
export const addAddress = function(param) {
    let url = baseURL + 'h5/lottery/v1.0.5.6/addAddress';
    return axios.post(url, param.data, { headers: param.headers });
}

//提交收货地址
export function saveMyAddress(param) {
    let url = baseURL + 'h5/address/add'
    return axios.post(url, param.data, { headers: param.headers })
}

//可填写填写地址时间点
export function queryAddressEndTime(param) {
    let url = baseURL + 'h5/activityConf/getAddressEndDate/' + param.data.actSign
    return axios.post(url, param.data, { headers: param.headers })
}

//实物奖品地址查询
export function getMyAddress(param) {
    let url = baseURL + 'h5/address/getUserAddress'
    return axios.post(url, param.data, { headers: param.headers })
}

//获取数据库时间
export function getDBTime() {
    let url = baseURL + 'game/marketingClient/v1.0.0.4/queryDbSysdate'
    return axios.post(url, {})
}

//用户昵称头像
export function getUserInfo(param) {
    let url = baseURL + 'user/userService/userInfo'
        // console.log(param)
    return axios.post(url, '', { headers: param.headers })
}
//用户昵称头像
export function getAddressUserInfo(param) {
    let url = baseURL + 'user/userService/userInfo'
        // console.log(param)
    return axios.post(url, '', { headers: getHeaders() })
}
//点击抽奖接口
export function drawLottery(param) {
    let url = baseURL + '/h5/lottery/draw'
    return axios.post(url, param, { headers: getHeaders() })
}

//获取抽奖次数
export function getLotteryNumber(param) {
    let url = baseURL + 'h5/lottery/getLotteryNumber'
    return axios.post(url, param, { headers: getHeaders() })
}

//获取获奖用户列表
export function getUserList(param) {
    let url = baseURL + 'h5/lottery/marquee'
    return axios.post(url, param, { headers: getHeaders() })
}

//获取活动奖品
export function getPrizeList(param) {
    let url = baseURL + 'h5/lottery/listPrizes';
    return axios.post(url, param, {})
}

// 活动时间查询
export const getActivityDate = function(flag) {
    let url = baseURL + `h5/activityConf/getActivityDate/${flag}`;
    return axios.post(url, {}, {});
}

//我的奖品列表
export const queryPrizeList = function(param) {
    let url = baseURL + 'h5/lottery/listLotteryRecord'
    return axios.post(url, param.data, { headers: param.headers })
}

//2021/7/13
//实物奖品地址查询
export const queryActivityAddress = function(param) {
        let url = baseURL + 'h5/address/v1.0.4.8/queryActivityAddress'
        return axios.post(url, param.data, { headers: param.headers })
    }
    //提交收货地址
export const submitActivityAddress = function(param) {
    let url = baseURL + 'h5/address/v1.0.4.8/submitActivityAddress'
    return axios.post(url, param.data, { headers: param.headers })
}


//领取勋章接口
export const receiveMedal = function(param) {
    let url = baseURL + 'member/medal/receiveMedal'
    return axios.post(url, param, { headers: getHeaders() })
}

//获取分享信息
export const queryShareInfo = function(param) {
    let url = baseURL + 'user/shareInfo/queryShareInfo'
    return axios.post(url, param, { headers: param.header })
}

//积分乐园活动兑换
export const exchangeIntegralToCommodity = function(param) {
        let url = baseURL + 'member/integralDetail/v1.0.2.3/exchangeIntegralToCommodity'
        return axios.post(url, param, { headers: getHeaders() })
    }
    //积分乐园活动保存时间校验
export const checkUpdateAddressTime = function(param) {
    let url = baseURL + 'member/integral/v1.0.5.7/checkUpdateAddressTime'
    return axios.post(url, param, { headers: getHeaders() })
}


// WEBPACK FOOTER //
// ./src/api/commonApi.js